import styled from 'styled-components'

const ListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > a + a,
  > div + div {
    margin-left: 20px;
  }

  > a:nth-child(3n) + a,
  > div:nth-child(3n) + div {
    margin-left: 0px;
  }

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    flex-direction: column;
    flex-wrap: nowrap;
    max-height: none;
    overflow-y: visible;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 20px;

    > a,
    > div {
      width: 100%;
      flex-shrink: 0;
    }

    > a + a,
    > div + div {
      margin-left: 0;
      margin-top: 16px;
    }
  }
`

export default ListWrapper
